import { Input, Tooltip } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { IInvoiceResult } from "../../../interfaces/invoice";
import { useMessageApi } from "../../../context/MessageContext";


interface AiLimitationFeedbackCellProps {
  record: IInvoiceResult;
  onSave: (id: number, value: { aiLimitationFeedback: string }) => Promise<void>;
}

const AiLimitationFeedbackCell: React.FC<AiLimitationFeedbackCellProps> = ({ record, onSave }) => {

  const [reason, setReason] = useState(record.aiLimitationFeedback || "");
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const messageApi = useMessageApi();

  const initialFeedbackRef = useRef(record.aiLimitationFeedback ?? "");
  const textAreaRef = useRef<any>(null);
  
  useEffect(() => {
  if (editing && textAreaRef.current) {
    const textarea = textAreaRef.current?.resizableTextArea?.textArea;

    if (textarea) {
      textarea.focus();
      const length = textarea.value.length;
      textarea.setSelectionRange(length, length);
    }
  }
}, [editing]);

  const handleSave = async () => {
    setLoading(true);
    try {
      const oldVal = initialFeedbackRef.current ?? "";
      const newVal = reason ?? "";
      if (oldVal !== newVal) {
        await onSave(Number(record.id), { aiLimitationFeedback: reason });
        initialFeedbackRef.current = newVal;
        messageApi.success("Saved!");
      }
      setEditing(false);
    } catch (err) {
      messageApi.error("Save failed!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 4,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          gap: 4,
        }}
      >
        <div style={{
          height: 20
        }}></div>
        {editing ? (
          <Input.TextArea
            ref={textAreaRef}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            onBlur={handleSave}
            onPressEnter={handleSave}
            autoSize={{ minRows: 2, maxRows: 4 }}
            style={{ fontSize: 12, width: "100%" }}
            disabled={loading}
          />
        ) : (
          <Tooltip title={reason || "No Feedback"} placement="topLeft">
            <div
              style={{
                minHeight: 24,
                padding: "2px 4px",
                border: "1px dashed #ccc",
                borderRadius: 4,
                cursor: "pointer",
                fontSize: 12,
                color: reason ? "inherit" : "#999",
                width: "100%",
              }}
              onClick={() => setEditing(true)}
            >
              {reason || "Click to edit"}
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default AiLimitationFeedbackCell;
